import React from 'react';
import propTypes from 'prop-types';
import {connect} from 'react-redux';
import lang from '../../constants/Languages.js';
import { HashLink as Link } from 'react-router-hash-link';

//import img
import homeImg from '../../assets/icons/home.svg';
import homeContrast from '../../assets/icons/home-white.svg';

import { getSpecialCharactersRemoved } from '../../scripts/TextMetadata.js';

const ItemBreadcrumbs = ({ clang, list, currentPage }) => {
    const getBreadcrumbsLink = (item, index) => {
        if (item.label === 'home') {
            return <li className="item__breadcrumbs__item" key={index}>
                        <Link className="item__breadcrumbs__link" to={'/'} title={lang[clang].title.home}>
                            <img src={homeImg} alt={ lang[ clang ].alt.home } className="item__breadcrumbs__item-img"/>
                            <img src={homeContrast} alt={ lang[ clang ].alt.home } className="item__breadcrumbs__item-img contrast"/>
                        </Link>
                    </li>;
        }

        return <li className="item__breadcrumbs__item" key={index}>
                    <Link
                        className="item__breadcrumbs__link"
                        to={`${item.link ? item.link : '/'}`}
                        scroll={el => el.scrollIntoView({ block: 'start' })}
                        title={lang[clang].breadcrumbs[item.label] ? lang[clang].breadcrumbs[item.label] : item.label}
                    >
                        {lang[clang].breadcrumbs[item.label] ? lang[clang].breadcrumbs[item.label] : item.label}
                    </Link>
                </li>;
    };

    return (
        <ul className="item__breadcrumbs">
            {list.map((listItem, index) => listItem ? getBreadcrumbsLink(listItem, index) : false)}
            {currentPage && <li className="item__breadcrumbs__item" dangerouslySetInnerHTML={{__html: getSpecialCharactersRemoved(currentPage)}}></li>}
        </ul>
    );
};


ItemBreadcrumbs.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(ItemBreadcrumbs);



// WEBPACK FOOTER //
// ./src/components/items/ItemBreadcrumbs.js